import React, { useRef } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../header';
import Footer from '../footer';
import Sidebar from '../sidebar';
import Megamenu from '../megamenu';
import Mobsidebar from '../mobile-sidebar';
import Carouselhome from '../home/carousel-home';
import Noiseproduction from '../../images/Project_Images/HTR1.webp';
import Acoustics from '../../images/Project_Images/HTR2.webp';
import Acoustical from '../../images/Project_Images/HTR3.webp';
import ScrollToTopButton from '../ScrollButton';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from 'react-slick';
function AcoustiHomeRajap() {
    const sliderRef = useRef(null);

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
    };

    const goToPrev = () => {
        sliderRef.current.slickPrev();
    };

    const goToNext = () => {
        sliderRef.current.slickNext();
    };
    return (

        <>
            <Helmet>
                <title>Our Scope in Acoustic Home Theater Project - Home Theater Contractor</title>
                <meta name="description" content="" />
                <meta name="robots" content="index, follow" />
                <meta property="og:title" content="Home Theater Project in Mangalore" />
                <meta property="og:description" content="Home Theater Installation, Supply & Installation of Acoustic Walls and Flooring" />
                <meta property="og:image" content="https://www.acousticalsurfaces.in/images/projects-slider/ht-mangalore-3.webp" />
                <meta property="og:locale" content="en-in" />
                <link rel="canonical" href="https://www.acousticalsurfaces.in/acoustic-projects/home-theater-project" />
                <link rel="alternate" href="https://www.acousticalsurfaces.in/acoustic-projects/home-theater-project" hreflang="en-in" />
                <meta name="geo.placename" content="India" />
                <meta http-equiv="content-language" content="IN" />
                <meta name="geo.region" content="india" />
            </Helmet>
            <Header />
            <section className="content">
                <div className="container">
                    <div className="row">
                        <div className="col-sm-3 sidemenu">
                            <Sidebar />
                        </div>
                        <div className="col-sm-9 product-page nopaddding">
                            <div className="container">
                                <div className="megamenu">
                                    <Megamenu />
                                </div>
                            </div>
                            <div className="image-slider pro-content">
                                <div id="caption-slide" className="slider-container">
                                    <div className="slider">
                                        <Slider {...settings} ref={sliderRef}>
                                            <div className="slide">
                                                <img src={Acoustical} className="img-fluid" alt="acoustical surface" />
                                            </div>
                                            <div className="slide">
                                                <img src={Acoustics} className="img-fluid" alt="acoustics" />
                                            </div>
                                            <div className="slide">
                                                <img src={Noiseproduction} className="img-fluid" alt="noise production" />
                                            </div>
                                        </Slider>
                                    </div>
                                    <div className="switch" id="prev" onClick={goToPrev} style={{ backgroundColor: "transparent" }}><span>&#10094;</span></div>
                                    <div className="switch" id="next" onClick={goToNext} style={{ backgroundColor: "transparent" }}><span>&#10095;</span></div>
                                </div>
                            </div>
                            <div className="row pro-content">
                                <div className="col-sm-12 writeup">
                                    <h3>Home Theater, Rajapalayam</h3>
                                    <p className="note">Location: Rajapalayam Tamilnadu</p>
                                    <p><strong>About Home Theater Project, Rajapalayam</strong>
                                        <br />For any home theatre project, ASI aims to create an immersive, high-quality acoustic experience. This state-of-the-art installation will transform the space into a hub of entertainment. Perfect for enjoying movies, music, and more, we deliver superior sound clarity, enhancing the overall experience with top-tier acoustic treatments. Through our expertise, we deliver tailored solutions.
                                    </p>
                                    <p>
                                        <strong> Our Scope</strong>
                                        <br />Our comprehensive home theater installation includes the supply and installation of Fabriwall for the walls and Decopanel for the ceiling. Our goal is to enhance and ensure a superior cinematic experience tailored to the client's needs.
                                    </p>
                                    <br />
                                    <hr />
                                </div>
                            </div>
                            <div className="col-sm-12 ourprojects">
                                <h5>OUR PROJECTS</h5>
                                <p style={{ margin: "15px" }}><b>We deliver high-performance acoustic solutions with precision, innovation, and quality craftsmanship.
                                    Explore our recently completed projects that reflect our expertise across diverse spaces.</b></p>
                                <div id="mixedSlider">
                                    <div className="MS-content">
                                        <Carouselhome />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='mobsidebar'>
                        <div className="col-sm-12">
                            <div className="container">
                                <div className="row">
                                    <Mobsidebar />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ScrollToTopButton />
            </section>
            <Footer />
        </>
    );
}
export default AcoustiHomeRajap;